<template>
  <div class="risk-info-container">
    <div class="wrap-box-left">
      <IndexTabs
        :key="rKey"
        ref="fxsj"
        :hot-word="hotWord"
        :country="fxsjCountry"
        :category="fxsjCategory"
        :form-items="['countries', 'categories', 'source']"
        show-more-height="90px"
        url="/front/article/risk"
        goto="pbrRiskDetail"
        module="fxsj"
        tag-field="label"
        @search="queryGHotword"
      ></IndexTabs>
    </div>

    <div class="wrap-box-right">
      <div class="pbr-title">
        {{ $t('label.information.informationRiskHotWords') }}
      </div>
      <div style="height: 400px;">
        <hot-word-analysis
          v-if="hotWordData.length"
          :word-data="hotWordData"
          @hotClick="hotClick"
        ></hot-word-analysis>
        <Empty v-else></Empty>
      </div>
      <div class="pbr-title">
        {{ $t('label.information.informationRiskHotspot') }}
      </div>
      <normal-list
        :page-size="6"
        :data="hotSpotData"
        :goto="'pbrRiskDetail'"
      ></normal-list>
    </div>
  </div>
</template>
<script>
import IndexTabs from "../info/IndexTabs";
import HotWordAnalysis from "../analysis/HotWordAnalysis";
import NormalList from "../index/NormalList.vue";
export default {
  name: "RiskEvent",
  components: {
    IndexTabs,
    HotWordAnalysis,
    NormalList
  },
  data() {
    return {
      rKey: new Date().getTime(),
      fxsjCountry: null,
      fxsjCategory: null,
      hotWord: "",
      hotWordData: [],
      hotSpotData: []
    };
  },
  methods: {
    queryGHotword(par) {
      let param = par ? { type: "fxsj", ...par } : { type: "fxsj" };
      this.$pbrApis.queryGHotword(param).then(res => {
        this.hotWordData = res.result;
      });
    },
    queryHotSpot() {
      this.$pbrApis.queryHotSpot({ type: "fxsj" }).then(res => {
        this.hotSpotData = res.result;
      });
    },
    hotClick(hotWord) {
      this.hotWord = hotWord;
    }
  },
  mounted() {
    this.queryGHotword();
    this.queryHotSpot();
  }
};
</script>
<style scoped>
.risk-info-container {
  display: flex;
}
</style>
